import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import axios from 'axios';
import { axiosPath, path } from '@/routing/helpers/router';
import * as currentPageAction from '@/store/actions/currentPageAction';
import useIsMounted from '@/layout/components/hooks/useIsMounted';
import AuthClientAmia from './Clients/AuthClientAmia';
import AuthClientAecq from './Clients/AuthClientAecq';

export default function AuthClientBaseScreen() {
  const { client } = useParams();
  const navigate = useNavigate();
  const isMounted = useIsMounted();
  const dispatch = useDispatch();
  const [errorMsg, setErrorMsg] = useState();
  const [validationSchema] = useState(
    Yup.object().shape({
      username: Yup.string().required('Requerido'),
      password: Yup.string().required('Requerido'),
    }),
  );

  const handleLogin = async (values) =>
    axios
      .post(axiosPath('api_r_user_login'), values)
      .then(async ({ data }) => {
        if (isMounted.current) {
          if (data['2fa_required']) {
            navigate(
              path({
                name: 'user_2fa_challenge',
                params: { method: data.method, challenge: data.challenge },
              }),
            );
          } else {
            await localStorage.setItem('t', data.token);
            await localStorage.setItem('rt', data.refresh_token);
            dispatch(currentPageAction.change('recentlyLoggedIn', true, true));
            navigate(
              path({
                name: 'user_home',
              }),
            );
          }
        }
      })
      .catch((e) => {
        if (e.response.status === 401) {
          setErrorMsg('Datos de acceso inválidos');
        }
      });

    switch (client) {
        case 'aecq':
            return <AuthClientAecq validationSchema={validationSchema} errorMsg={errorMsg} onHandleLogin={handleLogin} />;
        case 'amia':
            return <AuthClientAmia validationSchema={validationSchema} errorMsg={errorMsg} onHandleLogin={handleLogin} />;
        default:
            return <></>;
    }
}
